module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "cont"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack#ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/not#not"
    }
  }, [_c('em', [_vm._v("Note on Translations")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("  Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1    Hinduism")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2    Chinese Religions")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3    Buddhism")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4    Religions of the Fertile Crescent")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5    Religions of Ancient Greece and Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6    Christianity")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7    Islam")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8    Religions of Africa")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9    Religions of Oceania")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10    Religions of the Americas")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/conc#conc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ata#ata",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Author")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0